import * as environment from '../../../config/environment';
import { BaseAPI } from "../../BaseAPI";

class IzinTalepRaporAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetIzinTalepRapor";
        super(baseUrl);
    }

    getExportPdf(sqId: number, izinForm: number, vekalet: string, vekaletUnvan: string,
                 onayaSun: string, onayaSunUnvan: string, uygun: string, uygunUnvan: string,
                 onaylayan: string, onaylayanUnvan: string) {

        let request: IIzinTalepRaporRequest = {
            sqId: sqId,
            izinForm: izinForm,
            vekalet: vekalet,
            vekaletUnvan: vekaletUnvan,
            onayaSun: onayaSun,
            onayaSunUnvan: onayaSunUnvan,
            uygun: uygun,
            uygunUnvan: uygunUnvan,
            onaylayan: onaylayan,
            onaylayanUnvan: onaylayanUnvan
        };
        return this.post("", request, true);
    }
}

export default new IzinTalepRaporAPI();

interface IIzinTalepRaporRequest {
    sqId: number;
    izinForm: number;
    vekalet: string;
    vekaletUnvan: string;
    onayaSun: string;
    onayaSunUnvan: string;
    uygun: string;
    uygunUnvan: string;
    onaylayan: string;
    onaylayanUnvan: string;
}

export type { IIzinTalepRaporRequest };
